import { KeyInfo } from '../../components/common/types'
import {
  BaseActionType,
  DELETE_SIGNING_KEYS_SUCCESS,
  LOAD_MORE_SIGNING_KEYS_SUCCESS,
  LOAD_SIGNING_KEYS_SUCCESS,
  UPDATE_SIGNING_KEYS_SUCCESS,
  UPLOAD_SIGNING_KEYS_SUCCESS,
} from '../actions/actionTypes'

import { Keys, KeysReducerState } from './initialState'

const initialStateSigningKeys: Keys = { keys: [], continuationToken: '' }

export function signingKeysReducer(
  state = initialStateSigningKeys,
  action: BaseActionType,
): KeysReducerState {
  switch (action.type) {
    case UPDATE_SIGNING_KEYS_SUCCESS: {
      const signingKeys: KeyInfo[] = state.keys.map((signingKey) =>
        signingKey.keyId === (action.payload as KeyInfo).keyId
          ? (action.payload as KeyInfo)
          : signingKey,
      )
      return { ...state, keys: [...signingKeys] }
    }
    case LOAD_SIGNING_KEYS_SUCCESS:
      return action.payload as KeysReducerState
    case LOAD_MORE_SIGNING_KEYS_SUCCESS:
      return {
        continuationToken: (action.payload as KeysReducerState)
          .continuationToken,
        keys: [...state.keys, ...(action.payload as KeysReducerState).keys],
      }
    case DELETE_SIGNING_KEYS_SUCCESS: {
      const signingKeys = state.keys.filter(
        (signingKeys: KeyInfo) =>
          signingKeys.keyId !== (action.payload as KeyInfo).keyId,
      )
      return { ...state, keys: [...signingKeys] }
    }
    case UPLOAD_SIGNING_KEYS_SUCCESS: {
      return {
        ...state,
        keys: [action.payload as KeyInfo, ...state.keys],
      }
    }
    default:
      return state
  }
}
